/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataSharingRequestDto } from './DataSharingRequestDto';
import {
    DataSharingRequestDtoFromJSON,
    DataSharingRequestDtoFromJSONTyped,
    DataSharingRequestDtoToJSON,
    DataSharingRequestDtoToJSONTyped,
} from './DataSharingRequestDto';

/**
 * 
 * @export
 * @interface DataSharingRequestsResponseDto
 */
export interface DataSharingRequestsResponseDto {
    /**
     * List of data sharing requests
     * @type {Array<DataSharingRequestDto>}
     * @memberof DataSharingRequestsResponseDto
     */
    requests: Array<DataSharingRequestDto>;
    /**
     * Pagination information
     * @type {object}
     * @memberof DataSharingRequestsResponseDto
     */
    pagination: object;
}

/**
 * Check if a given object implements the DataSharingRequestsResponseDto interface.
 */
export function instanceOfDataSharingRequestsResponseDto(value: object): value is DataSharingRequestsResponseDto {
    if (!('requests' in value) || value['requests'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function DataSharingRequestsResponseDtoFromJSON(json: any): DataSharingRequestsResponseDto {
    return DataSharingRequestsResponseDtoFromJSONTyped(json, false);
}

export function DataSharingRequestsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataSharingRequestsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'requests': ((json['requests'] as Array<any>).map(DataSharingRequestDtoFromJSON)),
        'pagination': json['pagination'],
    };
}

export function DataSharingRequestsResponseDtoToJSON(json: any): DataSharingRequestsResponseDto {
    return DataSharingRequestsResponseDtoToJSONTyped(json, false);
}

export function DataSharingRequestsResponseDtoToJSONTyped(value?: DataSharingRequestsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'requests': ((value['requests'] as Array<any>).map(DataSharingRequestDtoToJSON)),
        'pagination': value['pagination'],
    };
}

